import script from "./point.vue?vue&type=script&setup=true&lang=js"
export * from "./point.vue?vue&type=script&setup=true&lang=js"

import "./point.vue?vue&type=style&index=0&id=40f1cd2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f1cd2d"]])

export default __exports__